import { render } from "./asignarUsuarioModal.vue?vue&type=template&id=8b3ec462&scoped=true"
import script from "./asignarUsuarioModal.vue?vue&type=script&lang=js"
export * from "./asignarUsuarioModal.vue?vue&type=script&lang=js"

import "./asignarUsuarioModal.vue?vue&type=style&index=0&id=8b3ec462&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b3ec462"]])

export default __exports__